import { EntThreePlusTwo, ThreePlusTwoResponse } from "../../../models/ThreePlusTwo/threePlusTwo";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";


export const threePlusTwoApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({


    getPieList: builder.query<ThreePlusTwoResponse, { year: number }>({

      query: (params) => ({
        url: "/passport-ruar-ws/pie",
        method: "POST",
        body: JSON.stringify(params)


      }),
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetPieListQuery,
} = threePlusTwoApi;
